(function () {
  'use strict';
  if (customElements.get('cart-overlays')) return;
  class SidebarHover {
    constructor(overlay) {
      this.overlay = overlay; this.dialog = overlay.dialog;
      this.controller = new AbortController();
      this.images = new Map(); this.token = 0;
      this.fine = matchMedia('(hover: hover) and (pointer: fine)');
      this.preview = document.createElement('div');
      this.preview.className = 'cart-sidebar-image-preview';
      this.preview.setAttribute('aria-hidden', 'true'); this.preview.hidden = true;
      // Stay in the cart's native dialog top layer; the preview never catches input.
      this.dialog.append(this.preview);
      const on = (target, type, listener, extra = {}) => target.addEventListener(type, listener, { ...extra, signal: this.controller.signal });
      on(this.dialog, 'click', event => this.route(event));
      on(this.dialog, 'pointermove', event => this.move(event));
      on(this.dialog, 'pointerleave', () => this.hide());
      on(this.dialog, 'close', () => this.hide());
      on(document, 'pointerdown', () => this.hide());
      on(document, 'scroll', () => this.hide(), { capture: true, passive: true });
      on(document, 'cart:updated', () => this.hide());
      on(document, 'visibilitychange', () => { if (document.hidden) this.hide(); });
      on(window, 'resize', () => this.hide());
      on(window, 'blur', () => this.hide());
      on(this.fine, 'change', () => this.hide());
      this.observer = new MutationObserver(() => {
        if (!this.source?.isConnected || !this.dialog.open || this.dialog.dataset.surface !== 'sidebar' || [...document.querySelectorAll('dialog[open], [aria-modal="true"]:not([hidden]):not([aria-hidden="true"])')].some(modal => modal !== this.dialog && !this.dialog.contains(modal))) this.hide();
      });
    }
    route(event) {
      if (this.dialog.dataset.surface !== 'sidebar' || event.defaultPrevented || event.button !== 0 || event.target.closest('a, button, input, textarea, select, label, [contenteditable], .product-details-quantity') || getSelection()?.toString()) return;
      const row = event.target.closest('.product--item');
      const link = row?.querySelector('.product-details-text a[href]');
      // Use the existing variant link. Native links and cart controls stay separate;
      // selected product text can still be copied without navigating away.
      link?.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window, ctrlKey: event.ctrlKey, metaKey: event.metaKey, shiftKey: event.shiftKey, altKey: event.altKey }));
    }
    move(event) {
      if (!this.fine.matches || event.pointerType !== 'mouse' || !this.dialog.open || this.dialog.dataset.surface !== 'sidebar') { this.hide(); return; }
      const source = event.target.closest('.product-image-container [data-cart-preview-image]');
      if (!source && !this.inThumbnailGap(event)) { this.hide(); return; }
      this.point = { x: event.clientX, y: event.clientY };
      if (source && this.source !== source) this.show(source);
      if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.position(); });
    }
    inThumbnailGap(event) {
      if (!this.source?.isConnected) return false;
      if (!this.source.closest('.cart-drawer-products')?.contains(event.target)) return false;
      const row = event.target.closest('.product--item') || this.source.closest('.product--item');
      const thumbnail = row.querySelector('.product-image-container [data-cart-preview-image]');
      if (!thumbnail) return false;
      const box = thumbnail.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right) return false;
      const above = event.clientY < box.top;
      const neighbour = (above ? row.previousElementSibling : row.nextElementSibling)
        ?.querySelector('.product-image-container [data-cart-preview-image]');
      if (!neighbour) return false;
      const nextBox = neighbour.getBoundingClientRect();
      // Bridge only the vertical thumbnail gap; copy and controls still dismiss.
      return above ? event.clientY >= nextBox.bottom : event.clientY > box.bottom && event.clientY <= nextBox.top;
    }
    async show(source) {
      this.hide(); this.source = source;
      const token = this.token;
      this.observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'data-surface'] });
      try {
        const url = source.dataset.cartPreviewImage;
        if (!this.images.has(url)) {
          const thumbnail = source.querySelector('img');
          const image = window.ThemeProductImages.create({ src: url, width: Number(thumbnail?.getAttribute('width')), height: Number(thumbnail?.getAttribute('height')) }, { sizes: '320px', cap: 640, loading: 'eager', alt: '', reveal: 'external' });
          const pending = window.ThemeProductImages.ready(image, { signal: this.controller.signal }).then(ok => {
            if (!ok) throw new Error('Image unavailable');
            return image;
          });
          this.images.set(url, pending);
          pending.catch(() => { if (this.images.get(url) === pending) this.images.delete(url); });
        }
        const image = await this.images.get(url);
        // The drawer's entrance transform temporarily changes fixed positioning.
        await Promise.all(this.dialog.getAnimations().map(animation => animation.finished.catch(() => {})));
        if (this.token !== token || !source.isConnected || !this.dialog.open) return;
        this.preview.replaceChildren(image.cloneNode());
        this.preview.hidden = false;
        this.position();
      } catch (_) { if (this.token === token) this.hide(); }
    }
    position() {
      if (!this.source || this.preview.hidden || !this.point) return;
      const size = this.preview.getBoundingClientRect();
      const view = window.visualViewport;
      const left = view?.offsetLeft || 0, top = view?.offsetTop || 0;
      const right = left + (view?.width || innerWidth), bottom = top + (view?.height || innerHeight);
      let x = this.point.x + 16, y = this.point.y + 16;
      if (x + size.width > right - 8) x = this.point.x - size.width - 16;
      if (y + size.height > bottom - 8) y = this.point.y - size.height - 16;
      x = Math.max(left + 8, Math.min(x, right - size.width - 8));
      y = Math.max(top + 8, Math.min(y, bottom - size.height - 8));
      this.preview.style.transform = `translate3d(${Math.round(x)}px, ${Math.round(y)}px, 0)`;
    }
    hide() {
      this.token++; this.source = null;
      cancelAnimationFrame(this.frame); this.frame = 0;
      this.preview.hidden = true;
      this.observer?.disconnect();
    }
    destroy() { this.hide(); this.controller.abort(); this.preview.remove(); this.images.clear(); }
  }
  customElements.define('cart-overlays', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController(); const options = { signal: this.abort.signal };
      this.api = window.ThemeCart;
      if (window.Shopify?.designMode) { const node = document.querySelector('[data-cart-config]'); if (node) Object.assign(this.api.config, JSON.parse(node.textContent)); }
      this.dialog = this.querySelector('dialog'); this.popup = this.querySelector('.cart-confirmation');
      this.sidebarHover?.destroy(); this.sidebarHover = new SidebarHover(this);
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.mobile.addEventListener('change', () => {
        // An open full cart stays a full cart across breakpoints, even when
        // the destination's add confirmation is a nonmodal corner notice.
        if (this.dialog.open && this.openedAsPopup) {
          this.dialog.dataset.surface = this.popupSurface();
        }
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('[data-drawer-close]')) this.close();
        if (event.target.closest('[data-popup-close]')) this.hidePopup(true);
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      }, options);
      this.dialog.addEventListener('close', () => this.unlock(), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('a[href], button, input, textarea, select, [tabindex]')]
          .filter(el => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length && !el.closest('[hidden], [inert]'));
        const first = controls[0], last = controls[controls.length - 1];
        if (!first) { event.preventDefault(); this.dialog.focus(); return; }
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.dialog)) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === this.dialog)) {
          event.preventDefault(); first.focus();
        }
      }, options);
      this.popup.addEventListener('pointerenter', () => clearTimeout(this.dismiss), options);
      this.popup.addEventListener('pointerleave', () => this.schedule(), options);
      this.popup.addEventListener('focusin', () => clearTimeout(this.dismiss), options);
      this.popup.addEventListener('focusout', () => this.schedule(), options);
      this.popup.addEventListener('keydown', event => { if (event.key === 'Escape') { event.stopPropagation(); this.hidePopup(true); } }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) clearTimeout(this.dismiss); else this.schedule(); }, options);
      document.addEventListener('cart:updated', () => this.timer(), options);
      document.fonts?.addEventListener('loadingdone', () => this.squareRemoveLetters(), options);
      this.preview(); this.timer();
    }
    disconnectedCallback() {
      this.sidebarHover?.destroy();
      this.abort.abort(); clearTimeout(this.dismiss); clearInterval(this.clock); this.unlock();
    }
    popupSurface() {
      const layout = this.mobile.matches ? this.dataset.popupLayout || 'bottom' : this.dataset.desktopPopupLayout || 'corner';
      return layout === 'top' || layout === 'bottom' ? layout : 'sidebar';
    }
    squareRemoveLetters() {
      const letter = this.dialog.querySelector('.cart-remove-letter');
      if (!letter) return;
      const style = getComputedStyle(letter);
      const context = document.createElement('canvas').getContext('2d');
      if (!context) return;
      // Measure the glyph's ink, not its line box. Shrink only the longer axis.
      context.font = `${style.fontStyle} ${style.fontWeight} 1000px ${style.fontFamily}`;
      const ink = context.measureText('x');
      const width = ink.actualBoundingBoxLeft + ink.actualBoundingBoxRight;
      const height = ink.actualBoundingBoxAscent + ink.actualBoundingBoxDescent;
      if (!(width > 0 && height > 0)) return;
      const side = Math.min(width, height);
      this.style.setProperty('--cart-x-scale-x', side / width);
      this.style.setProperty('--cart-x-scale-y', side / height);
    }
    open(trigger, surface = 'sidebar') {
      this.hidePopup(false);
      if (this.dialog.open) return;
      this.openedAsPopup = surface === 'popup';
      this.dialog.dataset.surface = this.openedAsPopup ? this.popupSurface() : 'sidebar';
      this.trigger = this.popup.contains(trigger) ? this.addTrigger : trigger || document.activeElement;
      window.themeSearchPopup?.close();
      window.themeGeoPicker?.close(true);
      document.dispatchEvent(new CustomEvent('theme:close-navigation'));
      this.scrollY = window.scrollY;
      this.bodyStyle = { position: document.body.style.position, top: document.body.style.top, width: document.body.style.width, overflow: document.body.style.overflow };
      Object.assign(document.body.style, { position: 'fixed', top: -this.scrollY + 'px', width: '100%', overflow: 'hidden' });
      this.dialog.showModal();
      this.squareRemoveLetters();
    }
    close() { this.sidebarHover?.hide(); this.dialog.close(); }
    unlock() {
      if (!this.bodyStyle) return;
      Object.assign(document.body.style, this.bodyStyle); this.bodyStyle = null;
      window.scrollTo(0, this.scrollY);
      if (this.trigger?.isConnected && this.trigger.getClientRects().length) this.trigger.focus({ preventScroll: true });
    }
    hidePopup(restore) {
      const focused = this.popup.contains(document.activeElement);
      this.popup.hidden = true; clearTimeout(this.dismiss);
      if (restore && focused && this.addTrigger?.isConnected) this.addTrigger.focus({ preventScroll: true });
    }
    schedule() {
      clearTimeout(this.dismiss);
      if (this.dataset.cartPreviewing || this.popup.hidden || document.hidden || this.popup.matches(':hover') || this.popup.contains(document.activeElement)) return;
      this.dismiss = setTimeout(() => this.hidePopup(false), 8000);
    }
    confirm(items, trigger, stale) {
      // A pending add can finish after the shopper opens the drawer. Its cart
      // contents already update; do not leave a second confirmation underneath.
      if (this.dialog.open) return;
      // Top/bottom popups reuse the live cart, quantity and checkout form.
      // If totals could not be confirmed, retain the honest corner notice.
      if (!stale && this.popupSurface() !== 'sidebar' && this.querySelector('[data-drawer-content] [data-cart-form]')) {
        this.open(trigger, 'popup');
        return;
      }
      this.addTrigger = trigger;
      const container = this.querySelector('[data-added-items]'); container.replaceChildren();
      items.forEach(item => {
        const row = document.createElement('div'); row.className = 'cart-added-item';
        const fallback = () => {
          const placeholder = document.createElement('div'); placeholder.className = 'cart-added-placeholder';
          placeholder.append(this.querySelector('[data-cart-image-placeholder]').content.cloneNode(true)); return placeholder;
        };
        const imageURL = item.image || item.featured_image?.url;
        if (imageURL) {
          try {
            const image = window.ThemeProductImages.create(imageURL, { sizes: '72px', cap: 320, loading: 'eager' });
            image.width = 72; image.height = 72;
            row.append(image);
          } catch (_) { row.append(fallback()); }
        } else row.append(fallback());
        const details = document.createElement('div');
        const text = (value, className) => { const p = document.createElement('p'); p.textContent = value; if (className) p.className = className; details.append(p); };
        text(item.product_title || item.title);
        (item.options_with_values || []).filter(option => option.value !== 'Default Title').forEach(option => text(option.name + ': ' + option.value));
        Object.entries(item.properties || {}).filter(([key, value]) => !key.startsWith('_') && value).forEach(([key, value]) => text(key + ': ' + value));
        if (item.selling_plan_allocation) text(item.selling_plan_allocation.selling_plan.name);
        if (item.quantity !== null) text(this.api.message('quantity').replace('[quantity]', item.quantity), 'cart-added-quantity');
        text(window.theme.money.format(item.final_price ?? item.price) + ' ' + this.api.message('each'));
        row.append(details); container.append(row);
      });
      const warning = this.querySelector('[data-popup-warning]'); warning.hidden = !stale;
      warning.textContent = this.api.message('added') + ' ' + this.api.message('check_total');
      this.popup.hidden = false; this.popup.scrollTop = 0; this.schedule();
    }
    timer() {
      clearInterval(this.clock);
      const element = this.querySelector('[data-drawer-content] [data-cart-timer]'); if (!element) return;
      const config = this.api.config.timer; element.hidden = true;
      if (!config?.enabled) return;
      const date = /^(\d{4})-(\d{2})-(\d{2})$/.exec(config.date || '');
      const time = /^(\d{2}):(\d{2})$/.exec(config.time || '');
      const valid = date && time && Number(time[1]) < 24 && Number(time[2]) < 60;
      const end = valid ? Date.UTC(+date[1], +date[2] - 1, +date[3], +time[1], +time[2]) - Number(config.zone) * 3600000 : NaN;
      const check = valid && new Date(Date.UTC(+date[1], +date[2] - 1, +date[3])).toISOString().slice(0, 10) === config.date;
      if (!check || !Number.isFinite(end)) {
        if (window.Shopify?.designMode) { element.hidden = false; element.textContent = 'Check the deadline date and time in Theme settings → Cart.'; }
        return;
      }
      const tick = () => {
        const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000)); element.hidden = seconds === 0;
        if (!seconds) { clearInterval(this.clock); return; }
        element.querySelector('span').textContent = Math.floor(seconds / 86400) + 'd ' + String(Math.floor(seconds / 3600) % 24).padStart(2, '0') + ':' + String(Math.floor(seconds / 60) % 60).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
      };
      tick(); if (!element.hidden) this.clock = setInterval(tick, 1000);
    }
    preview() {
      const configNode = document.querySelector('[data-cart-config]');
      if (configNode && window.Shopify?.designMode) Object.assign(this.api.config, JSON.parse(configNode.textContent));
      const mode = this.api.config.preview;
      if (!mode || mode === 'off') return;
      this.dataset.cartPreviewing = mode;
      if (mode === 'popup' && this.popupSurface() === 'sidebar') {
        this.confirm([{ product_title: 'Sample T-shirt', options_with_values: [{ name: 'Size', value: 'M' }], quantity: 1, price: 6000 }]);
        const notice = this.querySelector('[data-popup-warning]'); notice.hidden = false; notice.textContent = 'Editor preview — sample item';
        return;
      }
      const content = this.querySelector('[data-drawer-content]');
      if (mode === 'sidebar' || mode === 'popup') {
        content.replaceChildren(this.querySelector('[data-cart-sample]').content.cloneNode(true));
        content.querySelector('[data-cart-subtotal]').textContent = window.theme.money.format(6000);
        content.querySelectorAll('button, input').forEach(control => { control.disabled = true; });
        content.querySelectorAll('.additional-checkout-buttons, .cart-discount').forEach(el => el.remove());
        content.querySelectorAll('[data-cart-terms]').forEach(el => { el.id += '-preview'; el.closest('label').htmlFor = el.id; });
      }
      else { content.replaceChildren(); const empty = document.createElement('p'); empty.className = 'cart-drawer-empty'; empty.textContent = 'Your cart is empty.'; content.append(empty); }
      this.dialog.querySelector('cart-counter')?.setCount(mode === 'empty' ? 0 : 1);
      this.querySelector('[data-cart-preview-label]').hidden = false; this.open(undefined, mode === 'sidebar' ? 'sidebar' : 'popup');
    }
  });
})();
